import { LitElement, html, css } from 'lit'
import { consume } from '@lit/context'
import { breakpointContext, isOutletNavigationOpenContext, isSubMenuOpenContext } from './context.ts'
import { customElement, property } from 'lit/decorators.js'
import { TW, type Breakpoint } from '../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('button-open-outlet-menu')
export class ButtonOpenOutletMenu extends TwLitElement {

    @property({ type: String, attribute: 'text' })
    text: string = ''

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    @consume({context: isSubMenuOpenContext, subscribe: true})
    private _isSubMenuOpen: boolean = false

    @consume({context: isOutletNavigationOpenContext, subscribe: true})
    private _isOutletNavigationOpen: boolean = false

    static styles = css`
        :host {
            display: block;
        }
        :host([hidden]) {
            display: none;
        }
    `

    private _isDisplayAsIcon() {
        return [ 'xs', 'sm' ].includes( this._breakpoint?.name ?? '' )
    }

    private _isShown() {
        return ! this._isOutletNavigationOpen && ! this._isSubMenuOpen
    }

    render() 
    {
        if ( ! this._isShown() ) {
            this.setAttribute( 'hidden', '' )
            return html``
        }

        this.removeAttribute( 'hidden' )

        return this._isDisplayAsIcon()
            ? html`<div class="wp-block-button is-bmw-icon is-bmw-icon-location-pin-rg"><button class="wp-element-button cursor-pointer leading-0" aria-label="${this.text}" aria-expanded="${this._isOutletNavigationOpen}" aria-haspopup="dialog"></button></div>`
            : html`<div class="wp-block-button is-bmw-icon is-bmw-icon-location-pin-rg"><button class="wp-element-button cursor-pointer m-0 p-0 font-medium" aria-label="${this.text}" aria-expanded="${this._isOutletNavigationOpen}" aria-haspopup="dialog">${this.text}</button></div>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'button-open-outlet-menu': ButtonOpenOutletMenu
    }
}
